import { useTranslation } from "react-i18next";
import type { QrPresetId } from "./qrCodeTemplates";

interface QrPresetLayerProps {
  presetId: QrPresetId;
  restaurantName?: string;
  compact?: boolean;
}

export default function QrPresetLayer({
  presetId,
  restaurantName = "",
  compact = false,
}: QrPresetLayerProps) {
  const { t } = useTranslation();
  const name = restaurantName?.trim() || t("qrPresetRestaurantPlaceholder");
  const rootClass = `qr-preset-layer qr-preset-layer--${presetId}${
    compact ? " qr-preset-layer--compact" : ""
  }`;

  if (presetId === "minimal") {
    return (
      <div className={rootClass} aria-hidden="true">
        <div className="qr-preset-layer__accent-bar" />
        <div className="qr-preset-layer__minimal-top">
          <span className="qr-preset-layer__minimal-brand">{name}</span>
          <span className="qr-preset-layer__minimal-tag">{t("qrPresetMinimalTag")}</span>
        </div>
        <div className="qr-preset-layer__minimal-lines">
          <span />
          <span />
          <span />
        </div>
        <p className="qr-preset-layer__scan-label">{t("qrPresetScanLabel")}</p>
        <div className="qr-preset-layer__qr-frame qr-preset-layer__qr-frame--minimal" />
        <p className="qr-preset-layer__footer">{t("qrPresetFooterHint")}</p>
      </div>
    );
  }

  if (presetId === "elegant") {
    return (
      <div className={rootClass} aria-hidden="true">
        <div className="qr-preset-layer__elegant-header">
          <span className="qr-preset-layer__elegant-welcome">{t("qrPresetElegantWelcome")}</span>
          <h3 className="qr-preset-layer__elegant-name">{name}</h3>
        </div>
        <div className="qr-preset-layer__elegant-gold-rule" />
        <div className="qr-preset-layer__elegant-body">
          <p className="qr-preset-layer__elegant-sub">{t("qrPresetElegantSub")}</p>
          <div className="qr-preset-layer__elegant-ornament">
            <span />
            <span />
          </div>
          <p className="qr-preset-layer__scan-label qr-preset-layer__scan-label--elegant">
            {t("qrPresetScanLabel")}
          </p>
        </div>
        <div className="qr-preset-layer__qr-frame qr-preset-layer__qr-frame--elegant" />
        <p className="qr-preset-layer__footer qr-preset-layer__footer--elegant">
          {t("qrPresetFooterHint")}
        </p>
      </div>
    );
  }

  return (
    <div className={`${rootClass} qr-preset-layer--classic`} aria-hidden="true">
      <div className="qr-preset-layer__classic-header">
        <h3 className="qr-preset-layer__classic-name">{name}</h3>
        <p className="qr-preset-layer__classic-sub">{t("qrPresetClassicSub")}</p>
      </div>
      <div className="qr-preset-layer__classic-divider" />
      <div className="qr-preset-layer__classic-card" />
      <p className="qr-preset-layer__scan-label qr-preset-layer__scan-label--classic">
        {t("qrPresetScanLabel")}
      </p>
      <div className="qr-preset-layer__qr-frame qr-preset-layer__qr-frame--classic" />
      <div className="qr-preset-layer__classic-footer">
        <span>{t("qrPresetClassicFooter")}</span>
      </div>
    </div>
  );
}
